import { IgButton } from "@intelligems/ig-theme/IgButton";
import { RuleExperiencesDialog } from "../rules/RuleExperiencesDialog";
import type { RuleListUsage } from "../rules/ruleListRows";
import { experiencesLabel } from "./ruleSaveApplyState";

/** "Apply to N experiences?" — names every experience the Apply updates. */
export const RuleApplyChangesDialog = ({
  open,
  experiences,
  isApplying,
  disabledHint,
  saveAsNewDisabled,
  onClose,
  onApply,
  onSaveAsNew,
}: {
  open: boolean;
  experiences: readonly RuleListUsage[];
  isApplying: boolean;
  disabledHint: string | undefined;
  saveAsNewDisabled: boolean;
  onClose: () => void;
  onApply: () => void;
  onSaveAsNew: () => void;
}) => (
  <RuleExperiencesDialog
    open={open}
    title={`Apply to ${experiencesLabel(experiences.length)}?`}
    description={[
      "This updates the products shown in every experience below. If the change should only apply in one place, save it as a new rule instead.",
      disabledHint,
    ]
      .filter(Boolean)
      .join(" ")}
    experiences={experiences}
    onClose={onClose}
    actions={
      <>
        <IgButton
          color="link"
          disabled={isApplying || saveAsNewDisabled}
          onClick={onSaveAsNew}
          sx={{ mr: "auto !important", ml: "0 !important" }}
        >
          Save as a new rule
        </IgButton>
        <IgButton
          color="primary"
          loading={isApplying}
          disabled={isApplying || disabledHint !== undefined}
          onClick={onApply}
        >
          Apply
        </IgButton>
      </>
    }
  />
);
